// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__C5Jcj","loader":"Loader_loader__EIlpM","spin":"Loader_spin__k16nB"};